<script lang="ts">
    import {link} from 'svelte-spa-router'
    import Fa from 'svelte-fa'
    
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faUserPlus,faHomeUser,faSignIn,faVolumeHigh } from '@fortawesome/free-solid-svg-icons';
    import Marquee from 'svelte-fast-marquee';
    //import MarqueeTextWidget from "svelte-marquee-text-widget";
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    let myLink = dataSetting.homepage
    //window.onscroll = function() {myFunction()};
    var header = document.getElementById("myHeaders");
   // var sticky = header.offsetTop;
    let txtTitle = ''
    let objs
    if(dataSetting.other){
        objs = JSON.parse(dataSetting.other)
        if(objs.textslide==''){
            txtTitle = ' ยินดีต้อนรับสู่ '+dataSetting.title+'     '
        }else{
            txtTitle = objs.textslide
        }
        
    }
    
    // function myFunction() {
    // if (window.pageYOffset > sticky) {
    //     header.classList.add("sticky");
    // } else {
    //     header.classList.remove("sticky");
    // }
    // }
   
</script>
<div class="mains-blog-header" id="myHeaders" style="display: flex;">
    <div class="col-4">
        <a href="{dataSetting.homepage}" class="btn btn-outline-secondary btn-sm btn-gd top-home" style="--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .7rem;display:none;"><Fa icon={faHomeUser} /></a>
    </div>
    <div class="col-4" style="position: relative;z-index:99;">
        <img src="{dataSetting.logo_wallet}" class="img-fluid img-header">
    </div>
    <div class="col-4 text-end">
        <a href="{dataSetting.lineurl}" target="_blank"><span class="badge rounded-pill text-bg-success"><Fa icon={faLine} size="lg"/> {dataSetting.lineid}</span></a>
    </div>
    <div class="blog-slid" style="display: none;">
        <div class="fds" >
            <Fa icon={faVolumeHigh} size="md"/>
            ประกาศ
        </div>
        <Marquee pauseOnHover={false} speed={40} play={true} style="width:350px;">{txtTitle}</Marquee>
    </div>
</div>

<style>
    /* .sticky{
        position: fixed !important;
    } */
</style>